import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import "./Header.css";
import logoImg from "../../assets/logo.jpeg";
import { CONTACT } from "../../constants/contact";

function Header() {
  const { t, i18n } = useTranslation();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const toggleLanguage = () => {
    const newLang = i18n.language === "vi" ? "en" : "vi";
    i18n.changeLanguage(newLang);
    localStorage.setItem("language", newLang);
  };

  return (
    <>
      {/* Top bar */}
      <div className="top-bar">
        <div className="top-bar-container">
          <div className="top-bar-left">
            <span className="top-bar-item">
              <svg
                viewBox="0 0 24 24"
                width="14"
                height="14"
                fill="currentColor"
              >
                <path d="M6.62 10.79a15.053 15.053 0 006.59 6.59l2.2-2.2a1.003 1.003 0 011.01-.24c1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.1.31.03.66-.25 1.02l-2.2 2.2z" />
              </svg>
              <a href={`tel:${CONTACT.phone}`}>{CONTACT.phoneDisplay}</a>
            </span>
            <span className="top-bar-item">
              <svg
                viewBox="0 0 24 24"
                width="14"
                height="14"
                fill="currentColor"
              >
                <path d="M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z" />
              </svg>
              <a href={`mailto:${CONTACT.email}`}>{CONTACT.email}</a>
            </span>
          </div>
          <div className="top-bar-right">
            <div className="top-bar-social">
              <a
                href="https://facebook.com"
                className="top-bar-social-link"
                aria-label="Facebook"
                target="_blank"
                rel="noopener noreferrer"
              >
                <svg viewBox="0 0 24 24" width="16" height="16" fill="currentColor">
                  <path d="M22 12c0-5.52-4.48-10-10-10S2 6.48 2 12c0 4.84 3.44 8.87 8 9.8V15H8v-3h2V9.5C10 7.57 11.57 6 13.5 6H16v3h-2c-.55 0-1 .45-1 1v2h3v3h-3v6.95c5.05-.5 9-4.76 9-9.95z" />
                </svg>
              </a>
              <a
                href="https://tiktok.com"
                className="top-bar-social-link"
                aria-label="TikTok"
                target="_blank"
                rel="noopener noreferrer"
              >
                <svg viewBox="0 0 24 24" width="16" height="16" fill="currentColor">
                  <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.68v13.67a2.4 2.4 0 0 1-2.4 2.4 2.4 2.4 0 0 1-2.4-2.4 2.4 2.4 0 0 1 2.4-2.4c.34 0 .67.05.98.15V9.41a5.8 5.8 0 0 0-.98-.08 5.78 5.78 0 0 0-5.78 5.78 5.78 5.78 0 0 0 5.78 5.78 5.73 5.73 0 0 0 5.78-5.78v-3.03a7.28 7.28 0 0 0 3.77 1.04V9.71a4.83 4.83 0 0 1-3.77-3.02z" />
                </svg>
              </a>
              <a
                href="https://instagram.com"
                className="top-bar-social-link"
                aria-label="Instagram"
                target="_blank"
                rel="noopener noreferrer"
              >
                <svg viewBox="0 0 24 24" width="16" height="16" fill="currentColor">
                  <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zM5.838 12a6.162 6.162 0 1 1 12.324 0 6.162 6.162 0 0 1-12.324 0zM12 16a4 4 0 1 1 0-8 4 4 0 0 1 0 8zm4.965-10.322a1.44 1.44 0 1 1 2.881.001 1.44 1.44 0 0 1-2.881-.001z" />
                </svg>
              </a>
            </div>
            <button 
              className="top-bar-item lang-switch" 
              onClick={toggleLanguage}
              aria-label="Toggle language"
            >
              🌐 {t("topBar.language")}
            </button>
          </div>
        </div>
      </div>

      {/* Main header */}
      <header className="header">
        <div className="header-container">
          {/* Logo */}
          <div className="header-logo">
            <Link to="/">
              <img
                src={logoImg}
                alt="FastExpress Logo"
                className="logo-img"
              />
            </Link>
          </div>

          {/* Navigation */}
          <nav className={`header-nav ${mobileMenuOpen ? "nav-open" : ""}`}>
            <Link to="/services" className="nav-link">
              {t("nav.services")}
            </Link>
            <Link to="/pricing" className="nav-link">
              {t("nav.pricing")}
            </Link>
            <Link to="/tracking" className="nav-link">
              {t("nav.tracking")}
            </Link>
            <Link to="/about" className="nav-link">
              {t("nav.about")}
            </Link>
            <Link to="/contact" className="nav-link">
              {t("nav.contact")}
            </Link>
            <div className="tracking-box-header">
              <svg
                className="tracking-icon"
                viewBox="0 0 24 24"
                width="18"
                height="18"
                fill="#6a6f73"
              >
                <path d="M15.5 14h-.79l-.28-.27A6.471 6.471 0 0016 9.5 6.5 6.5 0 109.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z" />
              </svg>
              <input
                type="text"
                placeholder={t("hero.trackingPlaceholder")}
                className="tracking-input-header"
              />
              <button className="tracking-btn-header">{t("hero.trackingBtn")}</button>
            </div>
          </nav>

          {/* CTA */}
          <div className="header-actions">
            <Link to="/contact" className="btn-cta">
              {t("header.cta")}
            </Link>
          </div>

          {/* Mobile menu toggle */}
          <button
            className="mobile-menu-btn"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            aria-label="Menu"
          >
            <span
              className={`hamburger ${mobileMenuOpen ? "open" : ""}`}
            ></span>
          </button>
        </div>
      </header>
    </>
  );
}

export default Header;
